function hasNoPropertie(value) {
  return value?.trim();
}

export function isAdresseNullOrComplete(ligne, nom) {
  const components = ['intitule1', 'adresse1', 'ville', 'pays'];
  if (components.some(c => !hasNoPropertie(ligne[`${nom}.${c}`]))) {
    return components.every(c => !hasNoPropertie(ligne[`${nom}.${c}`]));
  }
  return true;
}

export function extraireLibelles(listeLibelle) {
  const regex = /"([^"]*)"/g;
  const result = listeLibelle.match(regex) || [];
  return result.map(match => match.slice(1, -1).trim());
}
